import { createFileRoute } from "@tanstack/react-router";
import { LegalTemplates } from "@/components/LegalTemplates";

function RouteComponent() {
  return <LegalTemplates />;
}

export const Route = createFileRoute("/_authenticated/legal-templates/")({
  component: RouteComponent,
  staticData: { page: "operations" },
});
